module.exports = __webpack_public_path__ + "img/10551389_L.79a2fd8e.png";